import React, { useState, useEffect, useRef, useCallback, use } from 'react';
import styled from 'styled-components';
import { Button, Checkbox, Form, message, notification } from 'antd';
import * as _ from 'lodash';
import ProfileProperties from '../../ProfileProperties';
import profileService from '../../../services/profileService';
import { fileService } from '../../../services/fileService';

const UpdateProfile = ({hideModal, angularScope, view, selectedItems}) => {

  const [form] = Form.useForm();
  const initialValuesRef = useRef({});

  const [loading, setLoading] = useState(false);
  const [updateBates, setUpdateBates] = useState(false);
  const [updateAuto, setUpdateAuto] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [currentValues, setCurrentValues] = useState({});
  const [documentData, setDocumentData] = useState([]);

  // call API to get document info for IDs in selectedItems
  useEffect(async () => {
    if (!_.isEmpty(selectedItems)) {
      const documentInfo = await fileService.getDocumentsInfo(selectedItems);
      setDocumentData(documentInfo.data);
    }
  }, [selectedItems]);

  useEffect(() => {
    setDisabled(!updateBates && !updateAuto);
  }, [updateBates, updateAuto]);

  useEffect(() => {
    if (!_.isEmpty(currentValues) && _.isEmpty(initialValuesRef.current)) {
      initialValuesRef.current = _.cloneDeep(currentValues);
    }

    const hasChanges =
      !_.isEmpty(currentValues) &&
      !_.isEqual(currentValues, initialValuesRef.current);
  
    setDisabled(!hasChanges);
  }, [currentValues]);

  const handleSubmit = useCallback(async () => {

    const { profileName, properties } = currentValues;

    const validateRequiredProperties = await profileService.validateRequiredProperties(properties);
		if(!validateRequiredProperties) return;

    setLoading(true);
    setDisabled(true);
    
    const item = documentData[0];

    profileService.validatePropertyValues(profileName, properties).then(res => {
      const responseMessage = res.data.message;
      if(responseMessage.length > 0) {
        message.error(responseMessage);
        setLoading(false);
        setDisabled(false);
        return;
      }
      else {

        // find all properties with property validationRule of 'batesnumber' and set the value to '' if updateBates is true 
        if(updateBates) {
          properties.forEach(property => {
            if(property.validationRule.toLowerCase() === 'batesnumber') {
              property.value = '';
            }
          });
        }

        // find all properties with property validationRule of 'autogenerated' and set the value to '' if updateAuto is true
        if(updateAuto) {
          properties.forEach(property => {
            if(property.validationRule.toLowerCase() === 'autogenerated') {
              property.value = '';
            }
          });
        }

        //uploadFiles(uploadBatch);
        const postData = {
          profileName: profileName,
          objectId: item.ID,
          //versionId: item.VersionID,
          currentValues: properties,
        //minor: item.Minor,
        };

        axios.post('/api/wt/profiles/update', postData).then((res) => {
          hideModal();
          angularScope.$broadcast('reloadGrid');
          notification.success({message: 'Profile updated successfully'});
        }
        ).catch((err) => {
          setLoading(false);
          setDisabled(false);
          message.error({content: 'Error updating profile'});
        });
      }
    })

  }, [updateBates, updateAuto, view, form, currentValues, documentData])

  return (
    <Container>
      <ProfileProperties
        selectedItems={documentData}
        // workingFolder={angularScope.workingFolder}
        setCurrentValues={setCurrentValues}
      />
      <OptionsContainer>
        <Checkbox style={{marginRight: '10px'}} onChange={(e) => setUpdateAuto(e.target.checked)}>
          Update Auto Generated properties
        </Checkbox>
        <Checkbox style={{marginRight: '10px'}} onChange={(e) => setUpdateBates(e.target.checked)}>
          Update Bates Number properties
        </Checkbox>
      </OptionsContainer>
      <div>
        <div style={{position: 'absolute', bottom: '20px', right: '20px'}}>
          <Button
            type="default"
            onClick={hideModal}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={handleSubmit}
            loading={loading}
            disabled={disabled}
            style={{marginLeft: '10px'}}
          >
            Submit
          </Button>
        </div>
      </div>
    </Container>
  );
};

const Container = styled.div`
  border-bottom: 1px solid #e8e8e8;
  height: calc(100% - 50px);
`

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: left;
  margin: 10px 0;
`

export default UpdateProfile;